var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "tabpanels", staticClass: "tab-panels" },
    [
      _c(
        "div",
        { staticClass: "tabs" },
        _vm._l(_vm.tabData, function(tab, index) {
          return _c("a", {
            key: index,
            class: { active: index === _vm.activeIndex },
            attrs: { href: "#" },
            domProps: { innerHTML: _vm._s(tab.title) },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.activeIndex = index
              }
            }
          })
        }),
        0
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "component-fade", mode: "out-in" } }, [
        _c("div", { key: _vm.activeIndex, staticClass: "content" }, [
          _c("h4", {
            staticClass: "mb-16",
            domProps: { innerHTML: _vm._s(_vm.tabData[_vm.activeIndex].title) }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "wysiwyg text-14 text-blue opacity-70",
            domProps: {
              innerHTML: _vm._s(_vm.tabData[_vm.activeIndex].content)
            }
          })
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }